import moment from 'moment';

/**
 * Module that returns the current date. Can be replaced with
 * another implementation, for example if you needed to time travel and return
 * a different current date
 */

function currentDate() {
    return new Date();
}

function currentDateAtMidnight() {
    return trimToMidnight(currentDate());
}

function getYear(date) {
    return date ? date.getUTCFullYear() : null;
}

function getMonth(date) {
    return date ? date.getUTCMonth() : null;
}

function getDate(date) {
    return date ? date.getUTCDate() : null;
}

function trimToMidnight(date) {
    const returnedDate = new Date(date);
    returnedDate.setHours(0, 0, 0, 0);
    return returnedDate;
}

function addDays(date, daysToAdd) {
    date.setDate(date.getDate() + daysToAdd);
    return date;
}
    
function getDayOfWeek(date) {
    // adding 1 to reflect CC implementation
    return date.getDay() + 1;
}

function getHour(date) {
    return date.getHours();
}

function addHours(date, hrsToAdd) {
    date.setHours(date.getHours() + hrsToAdd);
    return date;
}

function getCurrentTimeTrimmedToHour() {
    const time = this.currentDate();
    time.setMinutes(0, 0, 0);
    return time;
}

function compareIgnoreTime(date1, date2) {
    const date1NoTime = new Date(date1).setHours(0, 0, 0, 0);
    const date2NoTime = new Date(date2).setHours(0, 0, 0, 0);

    if (date1NoTime > date2NoTime) {
        return 1;
    }
    if (date1NoTime < date2NoTime) {
        return -1;
    }
    return 0;
}

function dateYearsAgo(date, years) {
    return moment(date)
        .subtract(years, 'years')
        .toDate();
}

function calculateAgeInYearsExt(later, earlier) {
    const laterDate = new Date(later);
    const earlierDate = new Date(earlier);
    let age = laterDate.getFullYear() - earlierDate.getFullYear();
    if (age < 0) {
        return 0;
    }
    const months = laterDate.getMonth() - earlierDate.getMonth();
    if (months < 0 || (months === 0 && laterDate.getDate() < earlierDate.getDate())) {
        age--;
    }
    return age;
}

export default {
    currentDate: currentDate,

    /**
     * Returns the current day at the beginning (00:00:00h) of the day.
     *
     * @returns {Date}
     */
    currentDateAtMidnight: currentDateAtMidnight,

    getYear: getYear,

    getMonth: getMonth,

    getDate: getDate,

    /**
     * Returns new date object with time portion set to zero
     * Original date parameter is not modified
     * @param date Initial date. Tis object is not modified
     * @returns {Date}
     */
    trimToMidnight: trimToMidnight,
    /**
     * Increments date by x number of days
     *
     * @param date Initial date. This object is not modified
     * @param daysToAdd (Integer} number of days to add
     * @returns {Date} new date object incremented by x days
    */
    addDays: addDays,
    
    /**
     * Returns days of week by number, where Sunday is first day of week with value 1,
     * and Saturday is last day of week with value 7.
     * Original date parameter is not modified
     * @param date Initial date. Tis object is not modified
     * @returns {Integer}
    */
    getDayOfWeek: getDayOfWeek,
    
    getHour: getHour,

    /**
     * Increments date by x number of hours
     *
     * @param date Initial date. This object is not modified
     * @param hrsToAdd (Integer} number of hours to add
     * @returns {Date} new date object incremented by 4 hours
     */
    addHours: addHours,

    /**
     * Returns the current time with minutes, seconds and milliseconds set to zero
     * @returns {*}
     */
    getCurrentTimeTrimmedToHour: getCurrentTimeTrimmedToHour,

    /**
     * Compares the dates of two Date objects minus dates.
     * @param date1 First date to check.
     * @param date2 Second date to check.
     * @returns {Number} -1 if date1 is before date2, 0 if they are equal, 1 if date2 is after date1.
     */
    compareIgnoreTime: compareIgnoreTime,

    /**
     * Returns a date set to the day x years prior
     */
    dateYearsAgo: dateYearsAgo,

    /**
     * Returns the difference between today and given date in years.
     * @param d Date to check (older).
     * @returns {Number} number of years.
     */
    calculateAgeInYearsExt: calculateAgeInYearsExt
};
